function HomePage() {
  return (
    <>
      <p className="eyebrow">Official Website</p>
      <h1>Vortax Studio</h1>
      <p className="subtitle">
        Small team. Sharp products. Playful technology.
      </p>
      <p className="content">
        We build software and games with a focused product mindset. Fast
        iterations, clear user experience, and reliable engineering.
      </p>
    </>
  );
}

export default HomePage;
